import { Node_Type } from "./../../ricos-types/index.js";
import Audio from "./audio.js";
const nodeViewRenderers = {
  [Node_Type.AUDIO]: Audio
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
